import { createContext } from "react";

const userContext = createContext();

export default userContext;
